import { Component, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Constants } from '../../entities/Constants';
import { IScaleHistoryV1, IxellAPIService } from '../../tools/api.service';
import { HeaderService } from '../../tools/header.service';

@Component({
  selector: 'app-scale-history',
  templateUrl: './scale-history.component.html',
  styleUrls: ['./scale-history.component.scss']
})
export class ScaleHistoryComponent implements OnInit {

  getHistorySub: any;
  historyLst: IScaleHistoryV1[] = [];
  historySource: any;

  displayedColumns0 = ["scaleHistoryID","orderDate", "code", "serialNumber", "activationID", "licenceStartDate", "licenceEndDate", 'activationCode', "oldScale"];
  displayedColumns: string[];

 

  constructor(private apiService: IxellAPIService, private headerService: HeaderService) { }

  ngOnInit() {
    this.headerService.changeLogo(null);
    this.headerService.changeCanBack(true);
    this.headerService.changeTitle("IxellWebLab");
    this.getData();
  }

  getData() {
    this.getHistorySub = this.apiService.getAllScaleHistory().subscribe(data => {
      data.forEach(element => {
        var orderDateUTC = new Date(Date.UTC(element.orderDate.getFullYear(), element.orderDate.getMonth(), element.orderDate.getDate(), element.orderDate.getHours(), element.orderDate.getMinutes()));
        element.orderDate = orderDateUTC;
      })
      this.historyLst = data;
      this.historySource = new MatTableDataSource(this.historyLst);
      this.displayedColumns = this.displayedColumns0;
    }, error => {
      console.log(error);
      if (this.getHistorySub != null) this.getHistorySub.unsubscribe();
    });
  }

  sortScale(sort: Sort, status: string) {
    var data = this.historyLst;
    Constants.sortScale(sort, status, data);
    this.historyLst = data.slice();
    this.historySource = new MatTableDataSource(this.historyLst);
  }

  applyFilter(filterValue: string) {
    this.historySource.filter = filterValue.trim().toLowerCase();
  }

  refresh() {
    this.getData();
  }
}
